import { OnInit, Component, transition, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import * as _ from 'lodash';

import { FADE_IN_OUT_ANIMATION } from '@shared/animations';
import { User, Language, Role } from '@shared/data';
import { UserQuery, RoleQuery } from '@shared/queries';
import { LoadingService } from '@shared/modules/loading';

@Component({
  selector: 'edit-user',
  styles: [require('./edit-user.component.scss')],
  template: require('./edit-user.component.html'),
  animations: [FADE_IN_OUT_ANIMATION]
})
export class EditUserComponent implements OnInit, OnDestroy {
  public user: User;
  public roles: Role[];
  public userId: string;
  public error: Parse.Error;

  public prevRole: Role;
  public newRole: Role;
  public isSaving: boolean;

  constructor(private router: Router, private route: ActivatedRoute, private loadingService: LoadingService) {
    this.user = new User();
  }

  public ngOnInit(): void {
    this.fetchRoles();

    this.route.params.subscribe((params) => {
      this.userId = params['id'];

      if (!this.userId) {
        return;
      }

      this.fetchUser();
    });
  }

  public ngOnDestroy(): void {
    this.user.revert();
  }

  // ===============================================================================================
  // Accessors
  // ===============================================================================================

  public get parentUrl(): string {
    return this.userId ? '../../' : '../';
  }

  public set roleId(roleId: string) {
    this.newRole = this.roles.find(o => o.id == roleId);
  }

  public get roleId(): string {
    return this.newRole ? this.newRole.id : '';
  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onSave(): void {
    this.loadingService.continue();
    this.isSaving = true;

    Parse.Cloud.run('saveUser', this.user.jsonObject).then(
      success => {
        let user = User.createWithoutData(success.id);
        let toSave = [this.newRole];

        if (!this.userId) {
          User.requestPasswordReset(this.user.email).then(
            result => {

            },
            error => {
              this.error = error;
            }
          );
        }

        if (this.prevRole && this.prevRole.id != this.newRole.id) {
          this.prevRole.users.remove(user);
          toSave.push(this.prevRole);
        }

        this.newRole.users.add(user);

        Parse.Object.saveAll(toSave).then(
          result => {
            this.router.navigate([this.parentUrl], { relativeTo: this.route });
          },
          error => {
            this.error = error;
            this.isSaving = false;
            this.loadingService.complete();
          }
        );
      },
      error => {
        this.error = error;
        this.isSaving = false;
        this.loadingService.complete();
      }
    );
  }

  // ===============================================================================================
  // Parse Methods
  // ===============================================================================================

  private fetchUser(): void {
    let query = new UserQuery(this.userId)

    this.loadingService.continue();

    query.first().then(
      result => {
        this.user = result;
        this.loadingService.complete();
        this.fetchPrevRole();
      },
      error => {
        this.error = error;
        this.loadingService.complete();
      }
    );
  }

  private fetchPrevRole() {
    let query = new RoleQuery()
      .notEqualTo(Role.NAME_KEY, Role.USER_ROLE)
      .equalTo(Role.USERS_KEY, User.createWithoutData(this.userId));

    query.first().then(
      result => {
        this.prevRole = result;
        this.roleId = this.prevRole.id;
      },
      error => {
        this.error = error;
      }
    )
  }

  private fetchRoles() {
    let query = new RoleQuery().notEqualTo(Role.NAME_KEY, Role.USER_ROLE);

    query.find().then(
      result => {
        let role = _.first(result);

        this.roles = result;

        if (!this.roleId) {
          this.roleId = role.id;
        }
      },
      error => {
        this.error = error;
      }
    )
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+user/edit-user/edit-user.component.ts